import React from 'react';
import { BundleImage } from '@cdaas/api-clients/dist/product-service-openapi';
import { Flex, Div, Gutter, Title, BodyText, GridBag, Button, Image as ImageComponent, Icon } from '@gaiads/telia-react-component-library';
import { useTranslation } from 'react-i18next';

import { removeEntityByIndex } from '../../../../utils/entities';

interface ImagesProps {
  title: string;
  images: BundleImage[] | undefined;
  handleImagesChange: (images: BundleImage[]) => void;
}

function Images(props: ImagesProps) {
  const { title, images, handleImagesChange } = props;
  const { t } = useTranslation('bundlescreen');

  const handleImageDeletion = (index: number) => {
    const updatedImages = removeEntityByIndex(images, index);
    handleImagesChange(updatedImages);
  };

  const displayableImages = (images || []).map(image => {
    const name = t('images_section.image_name_placeholder'); // TODO - not currently part of data model (should it be?)
    return { name, image };
  });

  return (
    <Flex directionColumn>
      <Title size="md">{title}</Title>
      <Gutter />
      <BodyText color="gray400">{t('images_section.info')}</BodyText>
      <Gutter />
      <Div>
        <GridBag>
          <GridBag.Item md={5}>
            <Button onClick={() => alert('TODO - uploading image files not yet implemented')}>{t('images_section.buttons.upload_image')}</Button>
          </GridBag.Item>
        </GridBag>
        <Gutter />
        {displayableImages.map((displayableImage, imageIndex) => (
          <GridBag key={imageIndex}>
            <GridBag.Item md={4}>
              <Div backgroundColor="gray100" margin={{ vertical: 'xs' }}>
                <Flex centeredVertically>
                  <Div flexItem>
                    <ImageComponent
                      style={{ height: '80px', width: '80px' }}
                      src={displayableImage?.image.small_size_url || ''}
                      alt={t('images_section.product_image_alt')}
                    />
                  </Div>
                  <Div flexItem={{ sizeMultiplier: 1.6 }} margin={{ horizontal: 'sm' }}>
                    <BodyText>{displayableImage.name}</BodyText>
                  </Div>
                  <Div flexItem={{ sizeMultiplier: 0.3 }} alignTextToRight>
                    <Icon
                      name="close-circle"
                      data-testid={`image-${imageIndex}-delete`}
                      size="sm"
                      color="gray500"
                      margin={{ horizontal: 'xs' }}
                      title={t('images_section.delete_image')}
                      onClick={() => handleImageDeletion(imageIndex)}
                      clickableAppearance
                    />
                  </Div>
                </Flex>
              </Div>
            </GridBag.Item>
          </GridBag>
        ))}
      </Div>
    </Flex>
  );
}

export default React.memo(Images);
